interface InsertPostTextOptions {
  content: string;
  insertedText: string;
  selectionStart: number;
  selectionEnd: number;
  maxLength: number;
}

interface PostTextInsertion {
  content: string;
  cursorPosition: number;
}

export const insertPostText = ({
  content,
  insertedText,
  selectionStart,
  selectionEnd,
  maxLength,
}: InsertPostTextOptions): PostTextInsertion | null => {
  const start = Math.max(0, Math.min(selectionStart, content.length));
  const end = Math.max(start, Math.min(selectionEnd, content.length));
  const nextContent = `${content.slice(0, start)}${insertedText}${content.slice(end)}`;

  if (nextContent.length > maxLength) return null;

  return {
    content: nextContent,
    cursorPosition: start + insertedText.length,
  };
};
